/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/check-small': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#242424" fill-rule="evenodd" d="M13.695 4.707l-7.707 7.707-3.707-3.707 1.414-1.414 2.293 2.293 6.293-6.293 1.414 1.414z" clip-rule="evenodd"/>'
  }
})
